import { render, staticRenderFns } from "./addMatter.vue?vue&type=template&id=422f9f34"
import script from "./addMatter.vue?vue&type=script&lang=js"
export * from "./addMatter.vue?vue&type=script&lang=js"
import style0 from "./addMatter.vue?vue&type=style&index=0&id=422f9f34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports